import { useEffect } from "react";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

export default function AuthGate({ children }: any) {
    const { isAuthenticated, login, isLoading } = useKindeAuth();

    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            login(); // Iniciar sesión automáticamente si el usuario no está logueado
        }
    }, [isAuthenticated, isLoading, login]);

    if (isLoading || !isAuthenticated) {
        return null; // Pantalla en blanco mientras redirige al login
    }

    return children; // Si está autenticado, mostrar tu App normal
}
